module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Upload Image")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "btn btn-default btn-file col-md-3"
  }, [_vm._v("\n            Browse "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileChanged
    }
  })]), _vm._v(" "), (_vm.imageData.length > 0) ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('img', {
    staticClass: "img-thumbnail",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "id": "blah",
      "src": _vm.imageData
    }
  })]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-113103cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-113103cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/corecontrols/formimageupload/formimageupload.scp.html
// module id = 449
// module chunks = 0